<template>
  <div>
    <div class="order-detail-boxshadow">
      <div class="order-detail-list">
        <div class="order-detail-item">
          <span> 投诉人类型 </span>
          <span>
            {{ allEnum.ComplaintType && allEnum.ComplaintType[BasicData.customer_type] }}
          </span>
        </div>
        <div class="order-detail-item">
          <span> 姓名 </span>
          <span>
            {{ BasicData.customer_name }}
          </span>
        </div>
        <contactPhone :BasicData="BasicData" />
        <div class="order-detail-item">
          <span> 投诉原因 </span>
          <span>
            {{ allEnum.ComplaintReason && allEnum.ComplaintReason[BasicData.complaint_reason] }}
          </span>
        </div>
        <div class="order-detail-item">
          <span> 被投诉对象 </span>
          <span>
            {{ BasicData.complaint_target }}
          </span>
        </div>
        <div class="order-detail-item">
          <span> 处理等级 </span>
          <span>
            <span :class="`${BasicData.complaint_level == 3 ? 'color-red' : ''}`">
              {{ allEnum.ComplaintLevel && allEnum.ComplaintLevel[BasicData.complaint_level] }}
            </span>
            <el-button
              v-if="BasicData.complaint_level !== 3"
              type="primary"
              size="mini"
              @click="upgradeShow = true"
            >投诉升级</el-button>
          </span>

        </div>
        <div class="order-detail-item">
          <span> 处理组 </span>
          <span>
            {{ BasicData.deal_groups_name }}
          </span>
        </div>
      </div>
    </div>
    <van-popup v-model="upgradeShow">
      <div class="complaint-action-checkbox">
        <el-radio-group v-model="level">
          <el-radio
            v-for="option in complaintLevelList"
            :key="option.key"
            :label="option.key"
          >{{ option.lable }}</el-radio>
        </el-radio-group>
        <div class="complaint-action-btn">
          <el-button
            size="mini"
            @click="upgradeShow = false"
          >取消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="loading"
            @click="workLevelUpdate"
          >提交</el-button>
        </div>

      </div>

    </van-popup>
  </div>
</template>

<script>
import complaintService from "@/apis/complaint/index.js";
import contactPhone from "./contactPhone.vue";
import { throttle } from "@/utils/utils";

export default {
  name: "complaintWorkInfo",
  components: {
    contactPhone,
  },
  props: {
    BasicData: {
      default() {
        return {};
      },
    },
    userInfo: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      allEnum: {},
      upgradeShow: false,
      complaintLevelList: [],
      level: "",
      loading: false,
    };
  },
  watch: {
    // BasicData: {
    //   handler(newVal) {
    //     if (newVal.complaint_level) {
    //       this.level = `${newVal.complaint_level}`;
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  created() {
    this.getComplaintAllEnum();
  },
  methods: {
    workLevelUpdate: throttle(function () {
      const { userInfo } = this;

      const params = {
        center_work_id: this.BasicData.Id,
        complaint_update_reason: Number(this.level),
        user_id: userInfo.user_id,
        user_name: userInfo.user_name,
      };
      this.loading = true;
      complaintService
        .workLevelUpdate(params)
        .then(() => {
          this.upgradeShow = false;
          this.loading = false;
          this.$emit("workMyWorkDetail");
        })
        .catch(() => {
          this.loading = false;
        });
    }, 500),
    getComplaintAllEnum() {
      complaintService.getComplaintAllEnum().then((res) => {
        const { ComplaintLevelUpdate } = res;
        const complaintLevelList = [];
        Object.keys(ComplaintLevelUpdate).forEach((key) => {
          complaintLevelList.push({
            key,
            lable: ComplaintLevelUpdate[key],
          });
        });
        this.complaintLevelList = complaintLevelList;
        this.allEnum = res;
      });
    },
  },
};
</script>

<style>
</style>